import React, { useEffect } from "react";
import { Row, Col, Button } from "../../common/utils/antd-imports/AntdImports";
import AboutPageImg from "../../../assests/images/about-us-image.jpg";
import "./AboutPage.css";
import { useNavigate } from "react-router-dom";
import BreadcrumbNav from "../../common/bread-crumbs/BreadCrumb";
const AboutPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const navigate = useNavigate();
  return (
    <>
      <div className="about-page">
        <div className="bread-crumb-static">
          <BreadcrumbNav />
        </div>
        <div className="container">
          <section className="section-padding">
            <Row justify="center" align="middle" className="about-title-row">
              <Col xs={24} sm={24} md={16} lg={12}>
                <div className="about-title">
                  <span className="about-title-black">About </span>
                  <span className="about-title-highlight">Us</span>
                </div>
                <div className="about-us-text">
                  Redefining Advertising for the Modern Era
                </div>
              </Col>
            </Row>
          </section>
          <Row>
            <Col span={24}>
              <img
                src={AboutPageImg}
                alt="AboutUsImage"
                className="responsive-image"
              />
            </Col>
          </Row>
          <section className="about-content-section section-padding">
            <Row gutter={[16, 16]} className="content-row-1">
              <Col xs={24} md={12} className="vision-column">
                <h1 className="vision-header">
                  <span className="vision-text-black">Our </span>
                  <span className="vision-text-highlight">Vision</span>
                </h1>
              </Col>
              <Col xs={24} md={12} className="paragraph-column">
                <p className="paragraph-text">
                  We believe in the power of connecting brands with audiences in
                  impactful ways. Our platform bridges the gap between
                  advertisers and premium ad spaces, transforming ideas into
                  eye-catching, results-driven campaigns. Whether you’re a local
                  business or a global brand, we provide the tools and insights
                  to make every campaign a success.
                </p>
              </Col>
            </Row>
            {/* Added below the content section */}
            <div className="responsive-box"></div>
          </section>

          <section className="section-padding">
            <div className="about-content-section ">
              <Row gutter={[16, 16]} className="content-row">
                <Col xs={24} md={12} className="vision-column">
                  <h1 className="vision-header">
                    <span className="vision-text-black">What We </span>
                    <span className="vision-text-highlight">Offer </span>
                  </h1>
                </Col>
                <Col xs={24} md={12} className="paragraph-column">
                  <div className="highlighted-text">
                    Diverse Advertising Spaces
                  </div>
                  <p className="paragraph-text">
                    From bustling city billboards to slower rural 
                    placements, discover ad spaces that suit your message and
                    resonate with your audience. With countless options, you’re
                    sure to find the perfect spot to make an impression.
                  </p>

                  <div className="highlighted-text">Smart Data & Insights</div>
                  <p className="paragraph-text">
                    Access (AI) Artificial Intelligence real-time 
                    analytics, monitor campaign performance, and receive 
                    customized recommendations. We help you make data-backed decisions
                    that maximize your reach and optimize your return on investment.
                  </p>

                  <div className="highlighted-text">Seamless Connections</div>
                  <p className="paragraph-text">
                    We simplify the process, so you can focus on what matters
                    most: telling your brand story. Our platform connects you
                    effortlessly with ad spaces tailored to meet your unique
                    goals.
                  </p>
                </Col>
              </Row>
              {/* Added below the content section */}
              <div className="responsive-box"></div>
            </div>
          </section>

          <section className="section-padding">
            <div className="about-content-section ">
              <Row gutter={[16, 16]} className="content-row">
                <Col xs={24} md={12} className="vision-column">
                  <h1 className="vision-header">
                    <span className="vision-text-black">Why </span>
                    <span className="vision-text-highlight">AMP ?</span>
                  </h1>
                </Col>
                <Col xs={24} md={12} className="paragraph-column">
                  <p className="paragraph-text">
                    At Advertising Marketplace, we’re more than just an advertising platform. We’re
                    your partner in creating efficient campaigns, reaching new
                    audiences, and driving growth. We’re committed to making
                    advertising accessible, powerful, and results-driven for
                    brands of all sizes.
                  </p>

                  <div className="mobile-RegisBtnContainer">
                    <div className="highlighted-text">
                      Ready to take your brand to new heights?
                    </div>
                    <p className="paragraph-text">
                      Join us today and start creating campaigns that make a
                      lasting impact
                    </p>
                    <div className="register-button-container">
                      <Button
                        className="register-now-btn"
                        type="primary"
                        onClick={() => navigate("/signup")}
                        id="about_page_register_btn"
                      >
                        Register Now
                      </Button>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default AboutPage;
